import { render, staticRenderFns } from "./OTServiceDisplay.vue?vue&type=template&id=07fd022e&scoped=true&lang=pug"
import script from "./OTServiceDisplay.vue?vue&type=script&lang=js"
export * from "./OTServiceDisplay.vue?vue&type=script&lang=js"
import style0 from "./OTServiceDisplay.vue?vue&type=style&index=0&id=07fd022e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd022e",
  null
  
)

export default component.exports